import SidebarItem
import js.objects.jso
import mui.icons.material.Dataset
import react.*
import react.dom.html.ReactHTML.button
import react.dom.html.ReactHTML.div
import react.dom.html.ReactHTML.h1
import react.dom.html.ReactHTML.h2
import react.dom.html.ReactHTML.h3
import react.dom.html.ReactHTML.img
import react.dom.html.ReactHTML.span
import react.dom.svg.ReactSVG.path
import react.dom.svg.ReactSVG.svg
import routes.EnumRoutes
import ui.components.DashboardIcon
import ui.components.DataSidebarMenu
import ui.components.InquiriesIcon
import ui.components.ListingsIcon
import ui.components.NavBar
import ui.components.OwnerSubmissionsIcon
import ui.components.ScheduleIcon
import web.cssom.*
import web.window.window



// Props interfaces
external interface SidebarItemProps : Props {
    var icon: ReactNode
    var label: String
    var isActive: Boolean?
    var to: String?
}

// SidebarItem Component
val SidebarItem = FC<SidebarItemProps> { props ->
    val content = div {
        className = ClassName(
            "flex items-center gap-3 w-full px-4 py-3 rounded-xl text-sm transition-colors " +
                    if (props.isActive == true) {
                        "bg-gray-300 text-black"
                    } else {
                        "bg-transparent text-black hover:bg-gray-100"
                    }
        )

        div {
            className = ClassName("text-boon-red")
            +props.icon
        }
        span {
            className = ClassName("font-normal")
            +props.label
        }
        onClick = {
            // Handle navigation here - you might use React Router's useNavigate
            kotlinx.browser.window.location.href = props.to.toString()
        }
    }

    props.to?.let { route ->
        // If you're using React Router, replace this with Link component
        button {
            className = ClassName("w-full")
            onClick = {
                // Handle navigation here - you might use React Router's useNavigate
                kotlinx.browser.window.location.href = route
                console.log("Navigate to: $route")
            }
            content
        }
    } ?: run {
        button {
            className = ClassName("w-full")
            content
        }
    }
}

external interface StatCardProps : Props {
    var icon: ReactNode
    var title: String
    var value: String
    var description: String
}

val StatCard = FC<StatCardProps> { props ->
    div {
        className = ClassName("flex-1 bg-boon-bg-pink rounded-2xl p-5 relative min-w-0")

        div {
            className = ClassName("absolute top-5 left-5")
            div {
                className = ClassName("w-8 h-8 bg-boon-bg-pink-light rounded-full")
            }
        }

        div {
            className = ClassName("absolute top-[33px] left-[23px] text-boon-primary")
            +props.icon
        }

        div {
            className = ClassName("mt-12")
            h3 {
                className = ClassName("text-lg font-normal text-black mb-2")
                +props.title
            }
            div {
                className = ClassName("text-sm font-normal text-black mb-1")
                style = jso<CSSProperties> {
                    fontFamily = string("Century Schoolbook, serif")
                }
                +props.value
            }
            div {
                className = ClassName("text-sm font-normal text-black")
                style = jso<CSSProperties> {
                    fontFamily = string("Century Schoolbook, serif")
                }
                +props.description
            }
        }
    }
}

// Main Dashboard Component
val Dashboard = FC<Props> {
    var activeNavItem by useState("Dashboard")
//    var isSidebarOpen by useState(false)

    div {
        className = ClassName("min-h-screen bg-white flex relative")

            // Navigation
            NavBar{
                this.activeNavItem = "Dashboard"
            }



        // Main Content
        div {
            className = ClassName("flex-1 p-4 lg:p-8 ml-0 lg:ml-0")

            // Header
            div {
                className = ClassName("text-center mb-6 mt-16 lg:mt-0")
                h1 {
                    className = ClassName("text-3xl lg:text-5xl font-normal text-black mb-4")
                    +"Welcome Admin!"
                }
                h2 {
                    className = ClassName("text-xl lg:text-2xl font-normal text-boon-primary")
                    +"Start Overview"
                }
            }

            // Stats Cards
            div {
                className = ClassName("flex flex-col lg:flex-row gap-4 mb-8")

                StatCard {
                    icon = createElement(ListingsIcon)
                    title = "Total Listings"
                    value = dataProperties.size.toString()
                    description = "All active property listings"
                }
                StatCard {
                    icon = createElement(OwnerSubmissionsIcon)
                    title = "Owner Submissions"
                    value = dataOwners.size.toString()
                    description = "New submissions this week"
                }
                StatCard {
                    icon = createElement(InquiriesIcon)
                    title = "Inquiries"
                    value = dataInquiries.size.toString()
                    description = "Buyers/Renters Inquiries"
                }
            }

            // Quick Actions
            div {
                className = ClassName("text-center mb-6")
                h3 {
                    className = ClassName("text-xl lg:text-2xl font-normal text-black")
                    +"Quick Actions"
                }
            }

            div {
                className = ClassName("flex flex-col sm:flex-row gap-4")

                button {
                    className = ClassName("bg-boon-primary text-white px-4 py-3 rounded-xl text-sm font-normal")
                    style = jso<CSSProperties> {
                        fontFamily = string("Century Schoolbook, serif")
                    }
                    onClick = {
                        kotlinx.browser.window.location.href = EnumRoutes.AddProperty.routeID
                    }
                    +"Add Listing"

                }
                button {
                    className = ClassName("bg-boon-bg-pink text-boon-primary px-4 py-3 rounded-xl text-sm font-normal")
                    style = jso<CSSProperties> {
                        fontFamily = string("Century Schoolbook, serif")
                    }
                    onClick = {
                        kotlinx.browser.window.location.href = EnumRoutes.OwnerSubmissions.routeID
                    }
                    +"View Submissions"
                }
                button {
                    className = ClassName("bg-boon-bg-pink text-boon-primary px-4 py-3 rounded-xl text-sm font-normal")
                    style = jso<CSSProperties> {
                        fontFamily = string("Century Schoolbook, serif")
                    }
                    +"Manage Content"
                }
            }
        }
    }
}

